import Lottie from 'lottie-react'
import androidAnimation from '../../assets/animations/android.json'
import { DARK_TREATMENTS, type DarkTreatment } from './darkTreatment'

interface AndroidIconProps {
  className?: string
  size?: number
  /** How the icon handles a dark surface. See darkTreatment.ts for what each costs. */
  darkTreatment?: DarkTreatment
}

const AndroidIcon = ({ className = "w-14 h-14", size, darkTreatment = 'silhouette' }: AndroidIconProps) => {
  return (
    <div className={className} style={{ aspectRatio: '1 / 1', contain: 'layout' }}>
      <div className={`${DARK_TREATMENTS[darkTreatment]} w-full h-full`}>
        <Lottie
          animationData={androidAnimation}
          loop={true}
          autoplay={true}
          style={{ width: size || '100%', height: size || '100%' }}
          rendererSettings={{
            preserveAspectRatio: 'xMidYMid meet'
          }}
        />
      </div>
    </div>
  )
}

export default AndroidIcon
